var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1017 7.26622L8.09127 13.2766C6.72443 14.6435 4.50836 14.6435 3.14152 13.2766C1.77469 11.9098 1.77469 9.69372 3.14152 8.32688L9.15193 2.31647C10.0632 1.40525 11.5405 1.40525 12.4518 2.31647C13.363 3.2277 13.363 4.70508 12.4518 5.61631L6.67705 11.391C6.22144 11.8466 5.48275 11.8466 5.02714 11.391C4.57153 10.9354 4.57153 10.1967 5.02714 9.74109L10.0947 4.6735",
    stroke: "#512DA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.78b76f885d05af7aeae8371ef7273a68.svg";
export { ForwardRef as ReactComponent };